import React from 'react';

import { styled } from '../theme';
import Text from './Text';

type TextType = 'normal' | 'bolder' | 'lighter';

type Props = {
    type?: TextType;
    className?: string;
    style?: React.CSSProperties;
};

const defaultProps = {
    type: 'normal' as const,
};

const getFontColor = (type: TextType, theme): string => {
    switch (type) {
        case 'lighter':
            return theme.color.gray70;
        default:
            return theme.color.jetBlack;
    }
};

const getFontWeight = (type: TextType, theme): string => {
    switch (type) {
        case 'bolder':
            return theme.typography.fontWeight.medium;
        default:
            return theme.typography.fontWeight.base;
    }
};

const getFontSize = (type: TextType, theme): string => {
    switch (type) {
        case 'lighter':
            return '1.4rem';
        default:
            return '1.5rem';
    }
};

const StyledText = styled(Text)<Props>(({ theme, type }) => ({
    fontFamily: theme.typography.fontFamily.medium,
    fontWeight: getFontWeight(type, theme),
    fontSize: getFontSize(type, theme),
    color: getFontColor(type, theme),
}));

const TableText: React.FC<Props> = React.forwardRef(({ type, ...props }, ref) => (
    <StyledText type={type} ref={ref} {...props} />
));

TableText.defaultProps = defaultProps;

export default TableText;
